import { warmGatewaySessionForBootstrap } from '@enter/auth';
import { resolveAppArea } from '@/contexts/app/area';
import { initializeCorePageReady, recordRumNavigation } from '@/features/observability/initial';
import {
    initializeDatadog,
    onRouterTransitionStart as datadogRouterTransitionStart,
} from '#datadog/runtime';
import {
    initializeLandingPageReady,
    onLandingPageReadyNavigation,
} from '@/lib/datadog/landing-page-ready';

// Next 在 hydration 前执行此入口；会话请求与页面模块下载并行，Provider 消费共享包的同一次在途请求。
if (typeof window !== 'undefined') {
    const area = resolveAppArea(window.location.pathname);
    if (area === 'public' || area === 'product') warmGatewaySessionForBootstrap();
}

initializeLandingPageReady();
initializeCorePageReady();
initializeDatadog(resolveAppArea);

export function onRouterTransitionStart(...args: Parameters<typeof datadogRouterTransitionStart>) {
    recordRumNavigation(args[0]);
    onLandingPageReadyNavigation(args[0]);
    return datadogRouterTransitionStart(...args);
}
